<template>
  <div class="right-menu__codeconfirm">
    <div class="right-menu__title">
      <h4>Код подтверждения</h4>
    </div>
    <div class="t-form marginBottom">
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.codeConfirm }">
          <input
            type="text"
            id="code-confirm"
            v-model="data.codeConfirm"
            @click="() => clearError('codeConfirm')"
            @keydown.enter="submit"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.codeConfirm }"
            for="sing-up-name"
          >
            Введите код
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.codeConfirmText }}</span>
        </div>
      </div>
      <Timer v-if="timer" @onFinish="onFinishTimer" />
      <div v-if="!timer" class="resend-btn" @click="resendCode">
        Отправить ещё раз
      </div>
    </div>
    <t-button type="small blue uppercase" :callback="submit"
      >Подтвердить</t-button
    >
  </div>
</template>

<script>
import Button from '@components/ui/button.vue';
import { router } from '@src/routes';
import Timer from '@components/ui/timer.vue';
import { mapMutations, mapActions, mapState } from 'vuex';
import { setPhoneFormat, resetPhoneFormat } from '@src/js/inputMasks.js';

export default {
  components: {
    't-button': Button,
    Timer,
  },
  data: function() {
    return {
      timer: true,
      data: {
        codeConfirm: '',
      },
      errors: {
        codeConfirm: false,
        codeConfirmText: '',
      },
      errorsText: {
        empty: 'Поле не должно быть пустым',
        shortPassword: 'Пароль должен быть 6 и более символов',
        mismatchPassword: 'Введеные пароли не совпадают',
        incorrectPassword: 'Неверный пароль',
        incorrectUser: 'Пользователя с таким телефоном не существует',
      },
    };
  },
  computed: {
    ...mapState('api', [
      'codeConfirm',
      'registrationFinish',
      'passwordRecover',
      'checkCode',
      'updateProfile',
      'sendCode',
    ]),
    ...mapState('params', [
      'token',
      'signUpInfo',
      'confirmCodeType',
      'recoveryPasswordPhone',
      'updateProfileCallback',
    ]),
  },
  methods: {
    ...mapActions('api', ['fetchRequest']),
    ...mapMutations('params', [
      'toogleCodeConfirm',
      'toogleSingup',
      'toggleRightMenu',
      'toogleUserMenu',
      'toogleAuth',
      'toggleNewPasswordBlock',
      'setAuthOn',
      'setToken',
    ]),
    validation: function() {
      Object.keys(this.data).forEach((item) => {
        if (!this.data[item].trim()) {
          this.setErrors(item, 'empty');
        }
      });
    },
    setErrors: function(id, error) {
      this.errors[id] = true;
      this.errors[id + 'Text'] = this.errorsText[error];
    },
    setErrorsQuery: function(id, errorText) {
      this[this.type + 'Errors'][id] = true;
      this[this.type + 'Errors'][id + 'Text'] = errorText;
    },
    clearError: function(id) {
      this.errors[id] = false;
    },
    form: function(data) {
      let _form = new FormData();
      Object.keys(data).forEach((item) => _form.append(item, data[item]));
      return _form;
    },
    submit: function() {
      this.validation();

      this.fetchRequest({
        url: this.checkCode,
        form: this.form({
          code: this.data.codeConfirm,
          token: this.token,
        }),
        success: (data) => {
          if (data.body.success) {
            if (this.confirmCodeType == 'PASWORD_RECOVERY') {
              this.toogleCodeConfirm();
              this.toggleNewPasswordBlock();
            }
            if (this.confirmCodeType == 'REGISTRATION') {
              this.fetchRequest({
                url: this.registrationFinish,
                form: this.form({
                  ...this.signUpInfo,
                  token: this.token,
                }),
                success: (data) => {
                  if (data.body.success) {
                    this.toogleAuth();
                    this.toggleRightMenu();
                    this.toogleUserMenu();
                    this.setAuthOn();
                    router.push('/personal');
                  }
                },
                error: (e) => {
                  console.log('codeconfirm ERRORR', e);
                },
              });
            }
            if (this.confirmCodeType == 'UPDATE_PROFILE') {
              this.updateProfileCallback();
            }
          } else {
            try {
              Object.keys(validateData.body.errors).forEach((item) => {
                this.setErrorsQuery(item, validateData.body.errors[item][0]);
              });
            } catch (e) {
              console.log('code form error');
            }
          }
        },
        error: (e) => {
          console.log('codeconfirm ERRORR', e);
        },
      });
    },
    resendCode: function() {
      this.timer = false;

      this.fetchRequest({
        url: this.sendCode,
        form: this.form({
          phone: this.recoveryPasswordPhone,
        }),
        success: ({ body }) => {
          console.log('success resend send code', body);
          if (body.token) {
            this.setToken(body.token);
            this.timer = true;
          }
        },
        error: (e) => {
          console.log('send code error', e);
        },
      });
    },
    onFinishTimer: function() {
      this.timer = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.marginBottom
  margin-bottom: 32px
.resend-btn
    display: inline-block
    font-size: 16px
    color: #5599DD
    border-bottom: 1px dashed #5599DD
    cursor: pointer
</style>



// WEBPACK FOOTER //
// src/templates/components/right-menu/ui/codeconfirm.vue